<template>
  <div class="v_sweep_all_background">
    <!-- 视频部分 -->
    <div class="v_sweep_video_all">
      <div class="v_sweep_refresh_page" v-if="refreshCount > 0">
        {{ refreshCount }}
      </div>
      <div class="v_sweep_over_page" v-if="overPageShow">
        <div class="v_sweep_over_page_text">仪式已结束</div>
      </div>
      <video
        id="video"
        ref="video"
        width="100%"
        class="v_sweep_video"
        :style="'opacity:' + videoOpacity + ';z-index:' + videoZindex + ';'"
        :muted="videoPreload"
        @timeupdate="videoTimeUpdate"
        @canplay="videoCanPlay"
        @ended="videoEnd"
        @click="videoClick"
      ></video>
      <video
        id="videoLoop"
        ref="videoLoop"
        width="100%"
        class="v_sweep_video"
        :style="
          'opacity:' + videoLoopOpacity + ';z-index:' + videoLoopZindex + ';'
        "
        :loop="videoLoop"
        :muted="videoLoopPreload"
        @timeupdate="videoLoopTimeUpdate"
        @canplay="videoCanPlay"
        @ended="videoLoopEnd"
        @click="videoClick"
      ></video>
      <!-- 背景音乐 -->
      <audio id="audio" ref="audio" loop></audio>
    </div>
    <!-- 工具条 -->
    <div class="v_sweep_tool" v-if="videoTool">
      <!-- 二维码 -->
      <img
        src="@/assets/images/video/QRCode.png"
        alt=""
        class="v_sweep_video_QRCode_icon"
        @click="toQRCode"
      />
      <div class="v_sweep_tool_content">
        <!-- 视频：开/关 -->
        <img
          src="@/assets/images/video/iv_pause.png"
          alt=""
          class="v_sweep_video_pause"
          v-if="videoPlay && !overSweepShow"
          @click="toPause"
        />
        <img
          src="@/assets/images/video/iv_play.png"
          alt=""
          class="v_sweep_video_play"
          v-if="!videoPlay && !overSweepShow"
          @click="toPlay"
        />
        <!-- 全屏：开/关 -->
        <img
          src="@/assets/images/video/iv_full_screen_yes.png"
          alt=""
          class="v_sweep_video_screen_full"
          v-if="!fullScreen"
          @click="fullScreenClick"
        />
        <img
          src="@/assets/images/video/iv_full_screen_no.png"
          alt=""
          class="v_sweep_video_screen_full"
          v-if="fullScreen"
          @click="fullScreenClick"
        />
        <!-- 弹幕：开/关  @click="changeTime"-->
        <div class="v_sweep_message_button_text">
          弹幕：
        </div>
        <img
          src="@/assets/images/video/iv_message_open.png"
          alt=""
          class="v_sweep_message_button_img"
          v-if="messageOpen"
          @click="toOpenMessage"
        />
        <img
          src="@/assets/images/video/iv_message_close.png"
          alt=""
          class="v_sweep_message_button_img"
          v-if="!messageOpen"
          @click="toOpenMessage"
        />
        <!-- 下一环节或仪式结束 -->
        <div
          :class="
            nextSweepShow || overSweepShow
              ? 'v_sweep_file_next'
              : 'v_sweep_file_next disable'
          "
          v-longpress:1000="nextSweep"
        >
          <div class="v_sweep_file_next_button">{{ nextSweepName }}</div>
        </div>
      </div>
    </div>
    <div
      class="v_sweep_tool_always"
      v-else
      v-longpress:1000="nextSweep"
      :key="'nextSweepKey' + nextSweepKey"
    >
      <!-- 下一环节或仪式结束 -->
      <div class="v_sweep_file_next" v-if="nextSweepShow || overSweepShow">
        <div class="v_sweep_file_next_button">{{ nextSweepName }}</div>
      </div>
    </div>
    <!-- 二维码 -->
    <div
      class="v_sweep_video_QRCode_flex"
      @click="hideQRCode"
      v-if="sweepQRCodeShow"
    >
      <div class="v_sweep_video_QRCode_div">
        <img :src="sweepQRCodeUrl" alt="" class="v_sweep_video_QRCode" />
        <i class="qrcodeRadio upLeft"></i>
        <i class="qrcodeRadio upRight"></i>
        <i class="qrcodeRadio downLeft"></i>
        <i class="qrcodeRadio downRight"></i>
      </div>
    </div>
    <!-- 弹幕内容 -->
    <div class="v_sweep_barrages_drop">
      <div v-show="messageOpen">
        <div class="v_sweep_barrages_item" id="divText1"></div>
        <div class="v_sweep_barrages_item" id="divText2"></div>
      </div>
      <div>
        <div
          id="hiddenText1"
          class="v_sweep_barrages_text"
          style="display: none"
        >
          <div class="v_sweep_barrages_text_item">
            <span class="v_sweep_message_item_name"></span>
            <span class="v_sweep_message_item_msg"></span>
          </div>
        </div>
        <div
          id="hiddenText2"
          class="v_sweep_barrages_text"
          style="display: none"
        >
          <div class="v_sweep_barrages_text_item">
            <span class="v_sweep_message_item_name"></span>
            <span class="v_sweep_message_item_msg"></span>
          </div>
        </div>
      </div>
      <div ref="barragesItem" style="width: 100%; height: 1rem"></div>
    </div>
    <!-- 视频选择 -->
    <div class="v_sweep_file_show" v-if="fileShow">
      <div class="v_sweep_file_show_content">
        <div v-if="fileViewShow">
          <div class="v_sweep_file_video">
            <draggable
              class="v_sweep_file_video_draggable"
              v-model="videoFiles"
              :options="{
                sort: true,
                disabled: false,
              }"
              group="videoFiles"
              filter=".unmover"
              @start="draggableSweepStart"
              @end="draggableSweepEnd"
              :move="draggableSweepMove"
            >
              <div
                v-for="(file, i) in videoFiles"
                :key="i"
                class="v_sweep_file_video_item"
              >
                <video class="v_sweep_file_video_item_video" :src="file.blob" />
                <p class="v_sweep_file_video_item_p">
                  {{ file.name.replace(".mp4", "") }}
                </p>
              </div>
              <div class="v_sweep_file_video_item unmover">
                <video
                  class="v_sweep_file_video_item_video"
                  :src="videoOver.blob"
                />
                <p class="v_sweep_file_video_item_p">
                  {{ videoOver.name.replace(".mp4", "") }}
                </p>
              </div>
            </draggable>
          </div>
          <div class="v_sweep_file_row bottom80">
            <div class="v_sweep_file_start" @click="startSweep">
              <div class="v_sweep_file_start_button">确定并开始</div>
            </div>
          </div>
        </div>
        <div v-else class="v_sweep_file_row height600">
          <div class="v_sweep_file_select" @click="selectFileClick">
            <img
              src="@/assets/images/video/iv_button.png"
              alt=""
              class="v_sweep_file_select_img"
            />
            <div class="v_sweep_file_select_button">选择本地文件</div>
          </div>
          <!-- <div class="v_sweep_file_download" @click="downloadVideo">
            <div class="v_sweep_file_download_button">下载文件</div>
          </div> -->
          <input
            class="v_sweep_file_select_input"
            type="file"
            id="selectFile"
            ref="selectFile"
            @change="selectFileChange($event)"
            multiple
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { perspnalLink } from "@/utils/utils";
import screenfull from "screenfull";
import $ from "jquery";
import axios from "axios";
import mixin from "./Mixins";
import draggable from "vuedraggable";
import JSZip from "jszip";
import SparkMD5 from "spark-md5";
import { Message } from "element-ui";

export default {
  mixins: [mixin],
  components: {
    draggable,
  },
  data() {
    return {
      sweepId: null,
      audioFiles: [],
      audioLoopBlob: null,
      videoFiles: [],
      videoIndex: 0,
      videoTime: 0,
      videoNames: "",
      videoLoop: true,
      videoOver: {
        name: "",
        blob: "",
      },
      videoPreload: false,
      videoLoopPreload: true,
      videoOpacity: 0.999,
      videoZindex: 1,
      videoLoopOpacity: 0.001,
      videoLoopZindex: 0,
      videoTool: false,
      videoPlay: false,
      videoPlayCloseScreen: false,
      nextSweepShow: false,
      nextSweepName: "下一环节",
      nextSweepKey: 1,
      overSweepShow: false,
      overPageShow: false,
      //即时通讯
      websocket: null,
      websocketClose: false,
      websocketHeartbeat: null,
      messageData: [],
      messageOpen: true,
      messageTop: true,
      //是否全屏
      fullScreen: false,
      //历史弹幕定时任务
      bulletScreenTimer: null,
      //加载中
      loadingAll: "",
      //视频展示
      fileShow: true,
      fileViewShow: false,
      //二维码
      sweepQRCodeShow: false,
      sweepQRCodeUrl: "",
      //页面渲染使用
      refreshCount: 0,
      //下载文件
      downloadFilesUrl:
        "https://zgsm.zhongguangshimei.com/app/sacrificial/sweep/线下祭祀.zip",
      downloadFiles: [
        {
          name: "摆供.zip",
          md5: "3512c34513e998014e996b591a954f2e",
        },
        {
          name: "分祚.zip",
          md5: "4209cdcb4718fc268c467bfda87532f3",
        },
        {
          name: "敬茶.zip",
          md5: "0d8ae06f254b2f274dbf4c68f9ad5658",
        },
        {
          name: "敬灯.zip",
          md5: "b9ece8a67d4971abb99ebe4b3063a0d8",
        },
        {
          name: "敬酒.zip",
          md5: "d2aa5aa8681c3382fbc41ed72e4a2778",
        },
        {
          name: "敬香.zip",
          md5: "fb5d38b77f31a2d6532b19b59d3ec813",
        },
        {
          name: "捎寄.zip",
          md5: "9a6c0cdd221839ac5b4bc7dd73377202",
        },
        {
          name: "献花.zip",
          md5: "3c9722345864d1d2e9aa21bcd8452b3e",
        },
        {
          name: "仪式结束.zip",
          md5: "1a04086a3ef418e8f2b40ecbce0f585a",
        },
      ],
    };
  },
  created() {
    document.title = "线下祭祀";
  },
  computed: {},
  mounted() {},
  methods: {
    checkFull() {
      // 判断浏览器是否处于全屏状态 （需要考虑兼容问题）
      var isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
    selectFileClick() {
      this.$refs.selectFile.dispatchEvent(new MouseEvent("click"));
    },
    loadingOpen() {
      this.loadingAll = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    loadingClose() {
      this.loadingAll.close();
    },
    async selectFileChange(e) {
      this.loadingOpen();
      this.videoIndex = 0;
      this.videoFiles = [];
      this.videoPlay = false;
      this.videoTool = false;
      this.$refs.video.src = "";
      this.$refs.videoLoop.src = "";
      $(this.$refs.video).show();

      let files = e.target.files;
      if (files.length < 2) {
        this.$message.error("请至少选择2个文件");
        this.loadingClose();
        return false;
      }
      let overIndex = -1;
      for (let i = 0; i < files.length; i++) {
        if (files[i].type.indexOf("zip") == -1) {
          this.$message.error("请添加zip格式的文件");
          this.loadingClose();
          return false;
        }
        let md5 = await this.readLocaleFileMd5(files[i]);
        //console.log(files[i].name, md5);
        //continue;
        //是否包含完成视频
        if (this.downloadFiles[this.downloadFiles.length - 1].md5 == md5) {
          overIndex = i;
          continue;
        }
        //验证Md5
        let hasMd5 = false;
        for (let j = 0; j < this.downloadFiles.length; j++) {
          if (this.downloadFiles[j].md5 == md5) {
            hasMd5 = true;
            break;
          }
        }
        if (!hasMd5) {
          this.$message.error("文件内容错误");
          this.loadingClose();
          return false;
        }
      }
      if (overIndex < 0) {
        this.$message.error("请添加仪式结束视频");
        this.loadingClose();
        return false;
      }
      //添加到数据源
      await this.unzipLocaleFile(files, overIndex);
      // this.videoFiles = Array.from(files).sort((a, b) =>
      //   a.name.localeCompare(b.name)
      // );
      this.fileViewShow = true;
      let file = document.getElementById("chooseFile");
      if (file != undefined) {
        file.value = "";
      }
      let file2 = document.getElementById("chooseFile2");
      if (file2 != undefined) {
        file2.value = "";
      }
      this.loadingClose();
    },
    readLocaleFileMd5(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = (e) => {
          const binary = e.target.result;
          const md5 = SparkMD5.ArrayBuffer.hash(binary);
          resolve(md5);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
      });
    },
    async unzipLocaleFile(files, overIndex) {
      const decoder = new TextDecoder("gbk");
      //console.log(files);
      let audioIndex = 0;
      let videoIndex = 0;
      for (let i = 0; i < files.length; i++) {
        const jszip = new JSZip();
        const zip = await jszip.loadAsync(files[i], {
          decodeFileName: (bytes) => {
            return decoder.decode(bytes);
          },
        });
        let temp = {};
        for (let filename in zip.files) {
          const fileData = await zip.files[filename].async("blob");
          if (filename.indexOf("视频") != -1) {
            temp.name = filename;
            temp.blob = window.webkitURL.createObjectURL(fileData);
          } else if (filename.indexOf("循环") != -1) {
            temp.nameLoop = filename;
            temp.blobLoop = window.webkitURL.createObjectURL(fileData);
          } else if (filename.indexOf("音乐") != -1) {
            this.audioFiles[audioIndex] = {
              name: filename,
              blob: window.webkitURL.createObjectURL(fileData),
            };
            audioIndex++;
          } else if (filename.indexOf("音效") != -1) {
            this.audioLoopBlob = window.webkitURL.createObjectURL(fileData);
          }
        }
        if (i == overIndex) {
          this.videoOver = {
            name: temp.name,
            blob: temp.blob,
            blobAudio: "",
          };
        } else {
          this.videoFiles[videoIndex] = {
            name: temp.name,
            blob: temp.blob,
            nameLoop: temp.nameLoop,
            blobLoop: temp.blobLoop,
            blobAudio: "",
          };
          videoIndex++;
        }
      }
      //console.log(this.audioFiles)
      //console.log(this.videoFiles)
    },
    // 获取总时长
    videoCanPlay() {
      this.refreshPage();
      //this.videoTimeAll = this.getVideoRef().duration;
      //this.videoTime = this.getVideoRef().currentTime;
    },
    // 更新进度时间
    videoTimeUpdate(e) {
      if (this.$refs.video.currentTime > 0) {
        if (this.videoPreload) {
          this.$refs.video.pause();
          this.$refs.video.currentTime = 0;
        } else {
          this.videoTime = Math.trunc(this.$refs.video.currentTime);
        }
      }
    },
    // 播放结束，切换下一个
    videoEnd(e) {
      if (this.videoIndex < this.videoFiles.length) {
        this.videoZindex = 0;
        this.videoLoopZindex = 1;
        this.videoOpacity = 0.001;
        this.videoLoopOpacity = 0.999;
        this.videoLoop = true;
        this.videoLoopPreload = false;
        this.$refs.videoLoop.play();
        this.videoPlay = true;
        this.nextSweepShow = true;
        this.nextSweepKey = this.nextSweepKey + 1;
        this.videoIndex = this.videoIndex + 1;
        //预加载
        if (this.videoIndex < this.videoFiles.length) {
          setTimeout(() => {
            this.$refs.video.src = this.videoFiles[this.videoIndex].blob;
            this.videoPreload = true;
            this.$refs.video.play();
          }, 1000);
        }
      } else {
        this.nextSweepShow = false;
        this.nextSweepName = "仪式结束";
        this.overSweepShow = true;
        this.nextSweepKey = this.nextSweepKey + 1;
      }
    },
    videoLoopTimeUpdate(e) {
      if (this.$refs.videoLoop.currentTime > 0) {
        if (this.videoLoopPreload) {
          this.$refs.videoLoop.pause();
          this.$refs.videoLoop.currentTime = 0;
        } else {
          this.videoTime = Math.trunc(this.$refs.videoLoop.currentTime);
        }
      }
    },
    videoLoopEnd(e) {
      if (this.videoIndex < this.videoFiles.length) {
        this.videoZindex = 1;
        this.videoLoopZindex = 0;
        this.videoLoopEndTimer(1);
        this.videoPreload = false;
        this.$refs.video.play();
        if (this.videoFiles[this.videoIndex].blobAudio != "") {
          //this.$refs.audio.src = this.videoFiles[this.videoIndex].blobAudio;
          this.$refs.audio.src = this.audioLoopBlob;
          this.$refs.audio.play();
          setTimeout(() => {
            this.$refs.audio.src =
              this.videoFiles[this.videoIndex - 1].blobAudio;
            this.$refs.audio.play();
          }, 2576);
        }
        this.videoPlay = true;
        this.nextSweepShow = false;
        this.videoIndex = this.videoIndex + 1;
      } else {
        this.nextSweepShow = false;
        this.nextSweepName = "仪式结束";
        this.overSweepShow = true;
        this.nextSweepKey = this.nextSweepKey + 1;
      }
    },
    videoLoopEndTimer(num) {
      if (num <= 25) {
        this.videoOpacity = this.videoOpacity + 0.04;
        this.videoLoopOpacity = this.videoLoopOpacity - 0.04;
        setTimeout(() => {
          this.videoLoopEndTimer(num + 1);
        }, 100);
      } else {
        this.videoOpacity = 0.999;
        this.videoLoopOpacity = 0.001;
        //预加载
        if (this.videoIndex < this.videoFiles.length) {
          this.$refs.videoLoop.src = this.videoFiles[this.videoIndex].blob;
          this.videoLoopPreload = true;
          this.$refs.videoLoop.play();
        }
      }
    },
    videoClick() {
      this.videoTool = !this.videoTool;
      // this.appendDivText({
      //   type: 1,
      //   name: "张三",
      //   content: "寄语：我试试看水立方卡视角了发动机萨拉克京东方！",
      // });
    },
    changeTime() {
      if (this.videoIndex % 2 == 1) {
        this.$refs.video.currentTime = this.$refs.video.duration - 2;
      }
    },
    //开弹幕
    toOpenMessage() {
      if (this.messageOpen) {
        this.messageOpen = false;
        this.websocket.send("CLOSE");
      } else {
        //document.getElementById("divText1").innerHTML = "";
        //document.getElementById("divText2").innerHTML = "";
        this.messageOpen = true;
        this.websocket.send("OPEN");
      }
    },

    toPlay() {
      if (this.videoIndex == 0) {
        //添加息屏事件
        let that = this;
        document.addEventListener("visibilitychange", () => {
          if (document.hidden) {
            if (that.videoPlay) {
              that.videoPlayCloseScreen = true;
              that.toPause();
            }
          } else {
            if (
              that.videoPlayCloseScreen &&
              !that.overSweepShow &&
              !that.overPageShow
            ) {
              that.toPlay();
            }
            that.videoPlayCloseScreen = false;
          }
        });
        //初始化WebSocket
        this.initWebSocket();
        //获取历史弹幕
        this.findBulletScreenByDmId();
        //心跳检测
        var websocketHeartbeat = {
          timeout: 3000, //每隔三秒发送心跳
          severTimeout: 5000, //服务端超时时间
          timeoutObj: null,
          serverTimeoutObj: null,
          start: function () {
            var _this = this;
            this.timeoutObj && clearTimeout(this.timeoutObj);
            this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
            this.timeoutObj = setTimeout(function () {
              //这里发送一个心跳，后端收到后，返回一个心跳消息，
              //onmessage拿到返回的心跳就说明连接正常
              console.log("PING");
              that.websocket.send("PING"); // 心跳包
              //计算答复的超时时间
              _this.serverTimeoutObj = setTimeout(function () {
                console.log("心跳检测到超时");
                that.websocket.close();
              }, _this.severTimeout);
            }, this.timeout);
          },
        };
        that.websocketHeartbeat = websocketHeartbeat;
        websocketHeartbeat = null;
        this.videoIndex = this.videoIndex + 1;
      }
      this.videoPlay = true;
      this.$refs.video.play();
      this.$refs.videoLoop.play();
      this.$refs.audio.play();
    },

    toPause() {
      this.videoPlay = false;
      this.$refs.video.pause();
      this.$refs.videoLoop.pause();
      this.$refs.audio.pause();
    },

    /**
     * 建立socket连接，调用时间：
     * 1.首次进入页面，如果不是查看记录，请求出来初始数据后，建立socket连接
     * 2.调用数据库查询完毕后
     * */
    initWebSocket() {
      let adminId = window.localStorage.getItem("zgjs_login_id");
      let dmId = this.$route.query.id;
      //初始化weosocket
      const wsuri = `${perspnalLink()}/socket/websocket/deadman/sweep/${adminId}/${dmId}`;
      //const wsuri = `ws://localhost:8866/websocket/deadman/sweep/${adminId}/${dmId}`;
      this.websocket = new WebSocket(wsuri);
      this.websocket.onmessage = this.websocketonmessage;
      this.websocket.onopen = this.websocketonopen;
      this.websocket.onerror = this.websocketonerror;
      this.websocket.onclose = this.websocketonclose;
    },

    websocketonopen() {
      //连接建立之后执行send方法发送数据
      console.log("成功");
      this.websocket.send("OPEN");
      this.websocketHeartbeat.start();
      this.websocketClose = false;
    },

    /**
     * 连接建立失败,断开连接
     * 1.查询一次数据库数据
     * 2.查询完后再次建立socket连接
     * */
    websocketonerror() {
      //连接建立失败重连
      console.log("连接建立失败");
      this.websocketClose = true;
      setTimeout(() => {
        this.initWebSocket();
      }, 5000);
    },

    websocketonmessage(e) {
      //数据接收
      //console.log("数据接收：", e);
      this.websocketHeartbeat.start();
      if (e.data == "PONG") {
        return;
      }
      if (e.data == "CLOSE") {
        this.websocketClose = true;
        return;
      }
      let that = this;
      if (e.data == "DM_ERROR") {
        this.websocketClose = true;
        this.websocket.close();
        return;
      }
      this.appendDivText(JSON.parse(e.data));
    },
    appendDivText(data) {
      if (data.type == 0) {
        this.videoLoop = false;
        return;
      }
      if (data.type == 2) {
        this.websocketsend({
          //videoList: this.videoNames,
          videoIndex: this.videoIndex,
          videoTime: this.videoTime,
          audioTime: this.$refs.audio.currentTime,
          videoMessageOpen: this.messageOpen ? 1 : 0,
        });
        return;
      }
      if (!this.messageOpen) {
        return;
      }
      //console.log(data)
      let htmlType = "";
      if (this.messageTop) {
        htmlType = "1";
      } else {
        htmlType = "2";
      }
      $("#hiddenText" + htmlType + " .v_sweep_message_item_name").html(
        data.name
      );
      $("#hiddenText" + htmlType + " .v_sweep_message_item_msg").html(
        data.content
      );
      var obj1 = $($("#hiddenText" + htmlType).html());
      obj1.attr("class", "v_sweep_message_spanText");
      let a = parseFloat($("#hiddenText" + htmlType).css("width"));
      obj1.css("right", a * -1);
      obj1.css("width", a);
      $("#divText" + htmlType).append(obj1);
      this.startText(obj1);
      this.messageTop = !this.messageTop;
    },
    startText(obj) {
      if (obj.prev().length == 0 || parseFloat(obj.prev().css("right")) > 100) {
        var right = parseFloat(obj.css("right"));
        obj.css("right", right + 1);
        if (right < this.$refs.barragesItem.offsetWidth) {
          setTimeout(() => {
            this.startText(obj);
          }, 10);
        } else {
          obj.remove();
        }
      } else {
        setTimeout(() => {
          this.startText(obj);
        }, 500);
      }
    },

    websocketsend(data) {
      //数据发送
      this.websocket.send(JSON.stringify(data));
    },

    websocketonclose(e) {
      //关闭
      console.log("断开连接", e);
      if (this.websocketClose) {
        return;
      }
      setTimeout(() => {
        if (this.websocketClose) {
          return;
        }
        this.initWebSocket();
      }, 5000);
    },
    //全屏
    fullScreenClick() {
      if (this.fullScreen) {
        this.fullScreen = false;
        screenfull.exit();
      } else {
        this.fullScreen = true;
        screenfull.toggle();
      }
    },
    //获取历史弹幕最新100条
    findBulletScreenByDmId() {
      let data = {};
      data = {
        data: this.$route.query.id,
        pageInfo: {
          page: 1,
          size: 200,
          total: 0,
        },
      };
      let headers = {
        "Content-Type": "application/json;charset=UTF-8;",
      };
      let request = new Request("/api/bygDeadManSweep/userDmList", {
        method: "POST",
        credentials: "include",
        headers: headers,
        body: JSON.stringify(data),
      });
      fetch(request)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.findBulletScreenByDmIdTimer(res.data, 0);
          }
        })
        .catch((err) => {
          this.findBulletScreenByDmIdTimer([], 0);
          console.log(err);
        });
    },
    //弹幕循环显示
    findBulletScreenByDmIdTimer(rows, index) {
      if (rows.length > index) {
        let isAppend = false;
        let right = 0;
        if (this.messageTop) {
          right = parseFloat(
            $("#divText1 .v_sweep_message_spanText:last-child").css("right")
          );
          if (isNaN(right) || right > 0) {
            isAppend = true;
          }
        } else {
          right = parseFloat(
            $("#divText2 .v_sweep_message_spanText:last-child").css("right")
          );
          if (isNaN(right) || right > 0) {
            isAppend = true;
          }
        }
        if (isAppend) {
          this.appendDivText(rows[index]);
          this.bulletScreenTimer = setTimeout(() => {
            this.findBulletScreenByDmIdTimer(rows, index + 1);
          }, 6000);
        } else {
          this.bulletScreenTimer = setTimeout(() => {
            this.findBulletScreenByDmIdTimer(rows, index);
          }, 1000);
        }
      }
    },
    draggableSweepStart(e) {
      //console.log("draggableSweepStart", e);
      $(".v_sweep_file_video_item_video").css(
        "height",
        $(".v_sweep_file_video_item_video").css("height")
      );
    },
    draggableSweepMove(e) {
      if (e.relatedContext.element == undefined) {
        return false;
      } else {
        return true;
      }
    },
    draggableSweepEnd(e) {
      this.refreshPage();
    },
    startSweep() {
      this.loadingOpen();
      let that = this;
      let audioIndex = 0;
      let audioFilesTemp = that.audioFiles.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      let videoFilesTemp = [];
      let videoList = "";
      let j = 0;
      for (let i = 0; i < that.videoFiles.length; i++) {
        videoFilesTemp[j] = {
          name: that.videoFiles[i].name,
          blob: that.videoFiles[i].blob,
          blobAudio: that.videoFiles[i].blobAudio,
        };
        if (i % 2 == 0) {
          videoFilesTemp[j].blobAudio = audioFilesTemp[audioIndex].blob;
          audioIndex++;
          if (audioIndex >= audioFilesTemp.length) {
            audioIndex = 0;
          }
        }
        j++;
        videoList += "," + that.videoFiles[i].name;
        videoFilesTemp[j] = {
          name: that.videoFiles[i].nameLoop,
          blob: that.videoFiles[i].blobLoop,
          blobAudio: "",
        };
        j++;
        videoList += "," + that.videoFiles[i].nameLoop;
      }
      videoFilesTemp[videoFilesTemp.length] = {
        name: that.videoOver.name,
        blob: that.videoOver.blob,
        blobAudio: that.videoOver.blobAudio,
      };
      videoList += "," + that.videoOver.name;
      let data = {
        data: {
          dmId: that.$route.query.id,
          videoList: videoList.substring(1),
        },
      };
      let headers = {
        "Content-Type": "application/json;charset=UTF-8;",
      };
      let request = new Request("/api/bygDeadManSweep/add", {
        method: "POST",
        credentials: "include",
        headers: headers,
        body: JSON.stringify(data),
      });
      fetch(request)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log(res);
          if (res.status == 1000) {
            that.sweepId = res.data.id;
            that.getUrlDataSource(res.data.qrCodeUrl).then((blob) => {
              that.sweepQRCodeUrl = URL.createObjectURL(blob);
            });
            that.videoIndex = 0;
            that.$refs.video.src = videoFilesTemp[0].blob;
            that.$refs.audio.src = videoFilesTemp[0].blobAudio;
            that.$refs.videoLoop.src = videoFilesTemp[1].blob;
            that.$refs.videoLoop.play();
            that.fileShow = false;
            that.videoFiles = videoFilesTemp;
            that.videoNames = videoList.substring(1);
            that.videoTool = true;
            // for (let i = 0; i < that.videoFiles.length; i++) {
            //   console.log(that.videoFiles[i].name);
            // }
          } else {
            that.$message.error("获取信息失败，请检查网络连接");
          }
          that.loadingClose();
        })
        .catch((err) => {
          console.log(err);
          Message.closeAll();
          that.$message.error("获取信息失败，请检查网络连接");
          that.loadingClose();
        });
    },
    refreshPage() {
      this.refreshCount++;
      setTimeout(() => {
        this.refreshCount = 0;
      }, 200);
    },
    nextSweep(isRun) {
      if (true) {
        if (isRun) {
          navigator.vibrate =
            navigator.vibrate ||
            navigator.webkitVibrate ||
            navigator.mozVibrate ||
            navigator.msVibrate;
          if (navigator.vibrate) {
            navigator.vibrate(500);
          }
          if (this.overSweepShow == true) {
            this.overSweep();
          } else {
            this.nextSweepShow = false;
            this.videoLoop = false;
          }
        }
        return;
      }
      let data = {
        data: this.$route.query.id,
      };
      let headers = {
        "Content-Type": "application/json;charset=UTF-8;",
      };
      let request = new Request("/api/bygDeadManSweep/next", {
        method: "POST",
        credentials: "include",
        headers: headers,
        body: JSON.stringify(data),
      });
      fetch(request)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log(res);
          if (res.status == 1000) {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    overSweep() {
      let that = this;
      let data = {
        data: that.$route.query.id,
      };
      let headers = {
        "Content-Type": "application/json;charset=UTF-8;",
      };
      let request = new Request("/api/bygDeadManSweep/over", {
        method: "POST",
        credentials: "include",
        headers: headers,
        body: JSON.stringify(data),
      });
      fetch(request)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log(res);
          if (res.status == 1000) {
            that.$refs.audio.src = "";
            that.$refs.video.src = "";
            that.$refs.videoLoop.src = "";
            that.videoTool = false;
            that.overSweepShow = false;
            that.overPageShow = true;
            that.websocketClose = true;
            that.websocketHeartbeat = null;
            that.websocket.close();
          } else if (res.status == 1008) {
            console.log("接口请求频繁");
          } else {
            that.$message.error("获取信息失败，请检查网络连接");
          }
        })
        .catch((err) => {
          console.log(err);
          Message.closeAll();
          that.$message.error("获取信息失败，请检查网络连接");
        });
      if (that.fullScreen) {
        screenfull.exit();
      }
    },
    async downloadVideo() {
      this.loadingOpen();
      let link = document.createElement("a");
      link.style.display = "none";
      document.body.appendChild(link);
      let data = await this.getUrlDataSource(
        this.downloadFilesUrl + "?" + Date.now()
      );
      link.href = URL.createObjectURL(data);
      link.download = "线下祭祀.zip";
      link.click();
      document.body.removeChild(link);
      this.loadingClose();
    },
    getUrlDataSource(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: "POST",
          url: "/api/common/getUrlDataSource",
          data: {
            data: url,
          },
          responseType: "blob",
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    toQRCode() {
      if (this.sweepQRCodeUrl) {
        this.sweepQRCodeShow = true;
      } else {
        let that = this;
        that.loadingOpen();
        let data = {
          data: this.sweepId,
        };
        let headers = {
          "Content-Type": "application/json;charset=UTF-8;",
        };
        let request = new Request("/api/bygDeadManSweep/info", {
          method: "POST",
          credentials: "include",
          headers: headers,
          body: JSON.stringify(data),
        });
        fetch(request)
          .then((response) => {
            return response.json();
          })
          .then((res) => {
            console.log(res);
            if (res.status == 1000) {
              that.sweepQRCodeUrl = res.data.qrCodeUrl;
              that.sweepQRCodeShow = true;
            }
            that.loadingClose();
          })
          .catch((err) => {
            console.log(err);
            that.loadingClose();
          });
      }
    },
    hideQRCode(e) {
      this.sweepQRCodeShow = false;
    },
  },
};
</script>

<style lang="stylus">
.v_sweep_all_background {
  width: 100%;
  height: 100%;
  background: #000000;
  box-sizing: border-box !important;
  position: relative;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;   /* Non-prefixed version, currently
  not supported by any browser */
}

.v_sweep_video_all {
  width: 100%;
  height: 100%;
  position: relative;
}

.v_sweep_video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  background-color: #000000;
}

.v_sweep_refresh_page {
  position: absolute;
  left: 0;
  top: 0;
}

.v_sweep_over_page {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;

  .v_sweep_over_page_text {
    border-radius: 10px;
    width: 260px;
    height: 60px;
    line-height: 56px;
    text-align: center;
    color: #ffffff;
    font-size: 40px;
    background-color: rgba(139, 139, 139, 0.7);
  }
}

.v_sweep_barrages_drop {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  white-space: nowrap;
  z-index: 3;

  .baberrage-lane {
    .blue {
      margin-top: 10px;
    }

    .green {
      margin-top: 80px;
    }

    .red .normal {
      margin-top: 150px;
      border-radius: 100px;
      background: #e68fba;
      color: #fff;
    }
  }

  .v_sweep_barrages_item {
    width: 100%;
    height: 80px;
    line-height: 80px;
    position: relative;
  }

  .v_sweep_barrages_text {
  }

  .v_sweep_message_spanText {
    position: absolute;
    right: 0;
    top: 0;
    height: 80px;
    line-height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .v_sweep_barrages_text_item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .v_sweep_message_item_name {
    font-size: 36px;
    font-weight: 500;
    color: #FFA600;
    // text-shadow: 0px 1px 2px rgba(195, 121, 0, 0.5);
    text-shadow: 0 0 2px #ab6a00, 0 0 2px #ab6a00, 0 0 2px #ab6a00, 0 0 2px #ab6a00, 0 0 2px #ab6a00, 0 0 2px #ab6a00, 0 0 2px #ab6a00;
    line-height: 80px;
    margin-right: 10px;
  }

  .v_sweep_message_item_msg {
    font-size: 36px;
    font-weight: 500;
    color: #FFFFFF;
    // text-shadow: 0px 1px 2px rgba(94, 94, 94, 0.5);
    text-shadow: 0 0 2px #505050, 0 0 2px #505050, 0 0 2px #505050, 0 0 2px #505050, 0 0 2px #505050, 0 0 2px #505050, 0 0 2px #505050;
    line-height: 80px;
  }
}

.v_sweep_file_show {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3;

  .v_sweep_file_show_content {
    position: fixed;
    width: 1000px;
    height: 600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    background-color: #fff;
    user-select: none;

    .v_sweep_file_video {
      margin: 70px 20px 20px 20px;

      .v_sweep_file_video_draggable {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: flex-start;
        width: 100%;
      }

      .v_sweep_file_video_item {
        float: left;
        width: 20%;
        text-align: center;

        .v_sweep_file_video_item_video {
          object-fit: cover;
          // width: 220px;
          // height: 141px;
          width: 150px;
          height: 96px;
        }

        .v_sweep_file_video_item_p {
          margin-top: 4px;
          margin-bottom: 60px;
          font-size: 16px;
        }
      }

      .v_sweep_file_row {
        height: 100px;
      }
    }

    .v_sweep_file_row.bottom80 {
      position: absolute;
      bottom: 80px;
      width: 100%;
    }

    .v_sweep_file_row.height600 {
      height: 600px;
    }

    .v_sweep_file_row {
      clear: both;
      display: flex;
      flex-direction: row;
      align-items: center; /* 垂直居中 */
      justify-content: center; /* 水平居中 */

      .v_sweep_file_select {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 190px;
        height: 50px;
        border-radius: 10px;
        background: linear-gradient(180deg, #f9c400 0%, #f19100 100%);
        cursor: pointer;
      }

      .v_sweep_file_download {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: 50px;
        border-radius: 10px;
        background: linear-gradient(180deg, #67bcff 0%, #0691ff 100%);
        margin-left: 20px;
        cursor: pointer;
      }

      .v_sweep_file_start {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: 50px;
        border-radius: 10px;
        // background: linear-gradient(180deg, #84ed50 0%, #67C23A 100%);
        background: linear-gradient(180deg, #f9c400 0%, #f19100 100%);
        cursor: pointer;
      }

      .v_sweep_file_select_img {
        width: 30px;
        height: 30px;
      }

      .v_sweep_file_select_button, .v_sweep_file_download_button, .v_sweep_file_start_button {
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
      }

      .v_sweep_file_select_input {
        display: none;
      }
    }
  }
}

.v_sweep_tool {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3;

  .v_sweep_video_QRCode_icon {
    position: fixed;
    left: -8px;
    bottom: -14px;
    width: 50px;
    height: 50px;
    margin: 40px;
  }

  .v_sweep_tool_content {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    min-width: 600px;
    height: 100px;

    .v_sweep_video_play, .v_sweep_video_pause {
      cursor: pointer;
      width: 35px;
      height: 35px;
      margin-right: 40px;
    }

    .v_sweep_video_screen_full {
      cursor: pointer;
      width: 35px;
      height: 35px;
      margin-right: 40px;
    }

    .v_sweep_message_button_text {
      font-size: 38px;
      font-weight: 500;
      color: #ffffff;
    }

    .v_sweep_message_button_img {
      width: 96px;
      height: 40px;
      cursor: pointer;
      margin-right: 40px;
    }
  }
}

.v_sweep_tool_always {
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 100px;
  z-index: 3;
}

.v_sweep_file_next {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 44px;
  border-radius: 10px;
  background: linear-gradient(180deg, #84ed50 0%, #67C23A 100%);
  // background: linear-gradient(180deg, #f9c400 0%, #f19100 100%);
  cursor: pointer;
  margin-right: 40px;
}

.v_sweep_file_next.disable {
  background: linear-gradient(180deg, #909399 0%, #909399 100%);
}

.v_sweep_file_next_button {
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
}

.v_sweep_video_QRCode_flex {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 4;
  display: flex;
  flex-direction: row;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */

  .v_sweep_video_QRCode_div {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    width: 350px;
    height: 350px;
    background-color: #ffffff;
    border-radius: 0.8rem;

    .v_sweep_video_QRCode {
      width: 280px;
      height: 280px;
    }

    .qrcodeRadio {
      position: absolute;
      width: 15px;
      height: 15px;
      background: url('~@/assets/images/space/radio.png') no-repeat scroll left center / 15px 15px;
      margin: 10px;
    }

    .qrcodeRadio.upLeft {
      top: 0;
      left: 0;
    }

    .qrcodeRadio.upRight {
      top: 0;
      right: 0;
    }

    .qrcodeRadio.downLeft {
      bottom: 0;
      left: 0;
    }

    .qrcodeRadio.downRight {
      bottom: 0;
      right: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Sweep/Sweep.vue